import PropTypes from 'prop-types';

// Import => Utilities
import {AcUUID} from '@asdf-utils';

export const Props = {
  /** The type of the text field */
  type: PropTypes.oneOf(['text', 'textarea', 'password', 'email', 'number']),
  /** The id of the text field */
  id: PropTypes.string,
  /** The name of the text field */
  name: PropTypes.string,
  /** The label for the text field */
  label: PropTypes.string,
  /** Any instruction you'd like to present to the user, eg. date format */
  instructions: PropTypes.string,
  /** The placeholder for the text field */
  placeholder: PropTypes.string,
  /** The initial value for the text field */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** The max length for the text field value */
  maxLength: PropTypes.string,
  /** Combined with type="number", the min value for the text field */
  min: PropTypes.string,
  /** Combined with type="number", the max value for the text field */
  max: PropTypes.string,
  /** If true, the text field is required */
  required: PropTypes.bool,
  /** If true, the text field is focussed when rendered */
  focus: PropTypes.bool,
  /** If true, the text field is disabled */
  disabled: PropTypes.bool,
  /** If true, the text field is readonly */
  readonly: PropTypes.bool,
  /** Callback function triggered on change */
  callback: PropTypes.func,
  /** Callback function triggered on blur */
  onBlur: PropTypes.func,
  /** Callback function triggered on focus */
  onFocus: PropTypes.func,
  /** For CSS customization */
  className: PropTypes.string,
};

export const DefaultProps = {
  id: AcUUID(),
  type: 'text',
  autocomplete: 'off',
  disabled: false,
  required: true,
  focus: false,
  readonly: false,
  indicator: false,
  withSuccess: true,
  additional: {},
};
